<template>

    <div class="container">
        
        <app-head title="Success" />

        <div class="my-5">
            <div class="mb-4">
                <div class="mb-2">
                    <i class="bi bi-check-circle display-2 text-success"></i>
                </div>
                <h1>{{ __('Vielen Dank für Ihre Bestellung') }}</h1>
                <div class="">
                    {{ __('Sie erhalten in Kürze Ihre Auftragsbestätigung per E-Mail.') }}
                </div>
            </div>

            <div>
                <inertia-link :href="route('orders.index', {from: 'checkout'})" class="btn btn-lg btn-outline-primary">
                    {{ __('Zur Bestellübersicht') }}
                </inertia-link>
                <inertia-link :href="route('home', {from: 'checkout'})" class="btn btn-lg btn-outline-secondary">
                    {{ __('Zur Startseite') }}
                </inertia-link>
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        props: [
            'orders',
        ],
        data() {
            return {
            }
        },
        components: {
        },
        methods: {
        },
    }
</script>